import { errorLoading, loaded, responseHandler, errorGetStatus, tokenInterceptor } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlServer
let page = 1
let maxPage = 1
let limit = 100
let isFetchingDatas = false

let pageHistory = 1
let maxPageHistory = 1
let limitHistory = 100
let isFetchingDatasHistory = false

export const notifWS = (state = { notifPreview: {}, notifPreviewAll: {}, notifList: [], history: [] }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.NOTIF.PREVIEW_NOTIF:
      return Object.assign({}, state, { notifPreview: action.datas })
    case Constants.ActionsConstants.NOTIF.PREVIEW_NOTIF_ALL:
      return Object.assign({}, state, { notifPreviewAll: action.datas, notifPreview: action.datas })
    case Constants.ActionsConstants.NOTIF.CLEAR_NOTIF_LIST:
      return Object.assign({}, state, { notifList: action.datas })
    case Constants.ActionsConstants.NOTIF.FETCH_NOTIF_LIST:
      return Object.assign({}, state, { notifList: state.notifList.concat(action.datas.content) })
    case Constants.ActionsConstants.NOTIF.CLEAR_HISTORY:
      return Object.assign({}, state, { history: action.datas })
    case Constants.ActionsConstants.NOTIF.FETCH_HISTORY:
      return Object.assign({}, state, { history: state.history.concat(action.datas.content) })
    default:
      return state
  }
}

export const setNotifPreview = (data) => {
  return {
    type: Constants.ActionsConstants.NOTIF.PREVIEW_NOTIF,
    datas: data,
  }
}
export const setNotifPreviewAll = (data) => {
  return {
    type: Constants.ActionsConstants.NOTIF.PREVIEW_NOTIF_ALL,
    datas: data,
  }
}

export const clearNotifList = (data) => {
  return {
    type: Constants.ActionsConstants.NOTIF.CLEAR_NOTIF_LIST,
    datas: [],
  }
}

export const clearHistoryInStore = (data) => {
  return {
    type: Constants.ActionsConstants.NOTIF.CLEAR_HISTORY,
    datas: [],
  }
}

export const setNotifList = (data) => {
  return {
    type: Constants.ActionsConstants.NOTIF.FETCH_NOTIF_LIST,
    datas: data,
  }
}

export const setHistory = (data) => {
  return {
    type: Constants.ActionsConstants.NOTIF.FETCH_HISTORY,
    datas: data,
  }
}

export function notifCalls(dispatch, appId, notif) {
  /**
   * Get a preview for filtering options for notif
   */
  function PreviewNotifAll() {
    let entryPoint = Constants.UrlsConstants.notifEntryPoint
    let method = Constants.MethodsWSConstants.NOTIF.PREVIEW_NOTIF

    let fakeObj = {}

    fetch(urlServer + entryPoint + method + appId, {
      method: 'POST',
      body: JSON.stringify(fakeObj),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setNotifPreviewAll(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }
  /**
   * Get a preview for filtering options for notif
   */
  function PreviewNotif() {
    let entryPoint = Constants.UrlsConstants.notifEntryPoint
    let method = Constants.MethodsWSConstants.NOTIF.PREVIEW_NOTIF
    fetch(urlServer + entryPoint + method + appId, {
      method: 'POST',
      body: JSON.stringify(notif),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(r => r.json())
      .then(data => {
        dispatch(setNotifPreview(data))
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  /**
  * Get a preview for filtering options for notif
  */
  function SendNotif() {
    let entryPoint = Constants.UrlsConstants.notifEntryPoint
    let method = Constants.MethodsWSConstants.NOTIF.SEND_NOTIF
    if (notif.isTechnical) {
      method = Constants.MethodsWSConstants.NOTIF.SEND_TECH_NOTIF
    }
    fetch(urlServer + entryPoint + method + appId, {
      method: 'POST',
      body: JSON.stringify(notif),
      headers: Constants.UrlsConstants.header,
    })
      .then(response => {
        tokenInterceptor(response)
        return responseHandler(response)
      })
      .then(response => {
        response.text().then(data => {
          if (data === 'true') {
            dispatch(loaded('Error.Croutons.pushSuccess'))
          } else {
            dispatch(errorLoading('Error.Croutons.pushError'))
          }
          console.log('do something?' + data)
        })
      })
      .catch(error => {
        if (errorGetStatus(error) === 401) {
          dispatch(errorLoading('Error.Croutons.authExpired'))
          fetchLogoutAction(dispatch).fetchLogout()
        }
      })
  }

  return {
    PreviewNotifAll,
    PreviewNotif,
    SendNotif,
  }
}

export function fetchNotifAction(dispatch, appid, notif) {
  function ClearNotifs() {
    page = 1
    maxPage = 1
    isFetchingDatas = false
    dispatch(clearNotifList())
  }

  function ClearHistory() {
    pageHistory = 1
    maxPageHistory = 1
    isFetchingDatasHistory = false
    dispatch(clearHistoryInStore())
  }

  function GetHistory() {
    if (pageHistory <= maxPageHistory && !isFetchingDatasHistory) {
      isFetchingDatasHistory = true
      let entryPoint = Constants.UrlsConstants.notifEntryPoint
      let method = Constants.MethodsWSConstants.NOTIF.FETCH_SENT
      fetch(urlServer + entryPoint + method + appid + '?sort=plannedNotification&dir=desc&page=' + page + '&size=' + limitHistory, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          maxPageHistory = data.totalPages
          if (maxPageHistory >= pageHistory) pageHistory++
          isFetchingDatasHistory = false
          dispatch(setHistory(data))
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          }
        })
    }
  }

  function GetNotifs() {
    if (page <= maxPage && !isFetchingDatas) {
      isFetchingDatas = true
      let entryPoint = Constants.UrlsConstants.notifEntryPoint
      let method = Constants.MethodsWSConstants.NOTIF.FETCH_TO_SEND_NOTIF
      fetch(urlServer + entryPoint + method + appid + '?sort=notificationDate&dir=desc&page=' + page + '&size=' + limit, {
        method: 'GET',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          maxPage = data.totalPages
          if (maxPage >= page) page++
          isFetchingDatas = false
          dispatch(setNotifList(data))
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          }
        })
    }
  }

  function DeleteNotif() {
    if (notif.id) {
      let entryPoint = Constants.UrlsConstants.notifEntryPoint
      fetch(urlServer + entryPoint + notif.id, {
        method: 'DELETE',
        headers: Constants.UrlsConstants.header,
      })
        .then(response => {
          tokenInterceptor(response)
          return responseHandler(response)
        })
        .then(data => {
          dispatch(loaded('Error.Croutons.deleteSuccess'))
          ClearNotifs()
          GetNotifs()
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.deleteError'))
          }
        })
    }
  }

  return {
    ClearNotifs,
    ClearHistory,
    GetHistory,
    GetNotifs,
    DeleteNotif,
  }
}
